// extracted by mini-css-extract-plugin
export default {"list":"_1vlbz","item":"_1_Whg","link":"_2CN4j","linkSelected":"_3MkrW"};